var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Tag',_vm._b({},'Tag',{
            ..._vm.computedProperties
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }